const REVERSE_API = "https://api.bigdatacloud.net/data/reverse-geocode-client";

export const getUserLocation = async (useGPS = false) => {
  if (useGPS && navigator.geolocation) {
    return new Promise((resolve) => {
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          const lat = position.coords.latitude;
          const lon = position.coords.longitude;

          try {
            const res = await fetch(`${REVERSE_API}?latitude=${lat}&longitude=${lon}&localityLanguage=en`);
            const data = await res.json();

            resolve({
              country_code: data.countryCode,
              country: data.countryName,
              city: data.city || data.locality || data.principalSubdivision,
              lat,
              lon,
              from: "gps",
            });
          } catch (error) {
            // console.warn("Reverse geocoding failed:", error);
            const ipLocation = await getLocationFromIP();
            resolve({ ...ipLocation, lat, lon, from: "ip-fallback" });
          }
        },
        async (error) => {
          // console.warn("Geolocation denied:", error.message);
          const ipLocation = await getLocationFromIP();
          resolve({ ...ipLocation, from: "ip" });
        },
        { timeout: 5000 }
      );
    });
  } else {
    // console.warn("Using IP fallback for location to avoid browser prompt");
    return await getLocationFromIP();
  }
};

const getLocationFromIP = async () => {
  try {
    const res = await fetch("https://ipapi.co/json/");
    const data = await res.json();
    return {
      country_code: data.country_code,
      country: data.country_name,
      city: data.city,
    };
  } catch (error) {
    // console.error("IP location fetch failed", error);
    return { country_code: null, country: null, city: null };
  }
};
